<template>
  <ion-page >
    <ion-content>

      <swiper-container
        :slides-per-view="1"
        pagination="true"
        style="height: 100%; --swiper-theme-color: #21B24B;"
        ref="swiper"
      >

        <!-- Slide 1: Add Profile -->
        <swiper-slide>
          <div class="slide">
            <img src="../../../public/assets/images/logo/rapid.png" alt="Profile GIF"  class="logo-spin"/>
            <div class="details-txt">
                <h2>Update Your Profile</h2>
                <p>Update Your Profile with Email Address and State Details</p>
            </div>
            <div class="buttons single">
              <!-- <ion-button fill="clear" @click="skipOnboarding">Skip</ion-button> -->
               <div class="spacer"></div>
              <ion-button class="nxt-btn" @click="nextSlide">Next</ion-button>
            </div>
          </div>
        </swiper-slide>

        <!-- Slide 2: Add EV Details -->
        <swiper-slide>
          <div class="slide">
            <img src="../../../public/assets/images/logo/rapid.png" alt="Profile GIF"  class="logo-spin"/>
            <div class="details-txt">
                <h2>Add EV Details</h2>
                <p>Add Your Evs in My E-Vehicle</p>
            </div>
            <div class="buttons">
              <ion-button fill="clear" @click="skipOnboarding">Skip</ion-button>
              <ion-button class="nxt-btn" @click="finishOnboarding">Start</ion-button>
            </div>
          </div>
        </swiper-slide>

      </swiper-container>

    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonButton } from '@ionic/vue'
import { register } from 'swiper/element/bundle'

register()

export default {
  name: 'Onboarding',
  components: { IonPage, IonContent, IonButton },

  data() {
    return {
      showOnboarding: true,
    }
  },

  methods: {
    nextSlide() {
      this.$refs.swiper.swiper.slideNext()
    },

    skipOnboarding() {
      this.$router.push('/customer/reservation')  
    },

    finishOnboarding() {
      this.$router.push('/customer/reservation')  
    }
  }
}
</script>

<style scoped>
.details-txt {
    padding-top: 40px;
}
.logo-spin {
  width: 180px;
  /* height: 120px; */
  /* animation: spin 2.5s linear infinite; */
}

/* @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} */
swiper-container {
  --swiper-pagination-bullet-size: 10px; 
  --swiper-pagination-bullet-inactive-color: #413f3f; 
}
.spacer {
  flex: 1;
  margin: 0 5px;
}
.slide {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}
.nxt-btn {
  --border-radius: 20px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 300px;
  margin-top: 60px;
}

.buttons.single {
  justify-content: flex-end;
}

ion-button:not([fill="clear"]) {
  --background: #21B24B; 
  --color: #ffffff;       
  flex: 1;
  margin: 0 5px;
}

ion-button[fill="clear"] {
  --color: #21B24B; 
  flex: 1;
  margin: 0 5px;
}
</style>